import {Component, Input, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {Subscription} from "rxjs";
import {StockMinimum} from "../../../../../core/models/gestion-stock/stock-minimum.model";
import {ProduitDeclinaisonDTO} from "../../../../../core/dtos/produit-declinaison-dto";
import {UtilsService} from "../../../../../core/utils/utils.service";
import {StockService} from "../../../../../core/services/entities/stock-service";
import {DxDataGridComponent} from "devextreme-angular";
import {ButtonThemeEnum} from '../../../../../shared/ui/button/button-theme-enum';

@Component({
  selector: 'yo-gestion-stock-minimum-dialog',
  templateUrl: './dialog-gestion-stock-minimum.component.html',
  styleUrls: ['./dialog-gestion-stock-minimum.component.scss'],
  standalone: false
})
export class DialogGestionStockMinimumComponent implements OnInit, OnDestroy {


  public readonly ButtonThemeEnum = ButtonThemeEnum;



  constructor(private stockSvc: StockService,
              private utils: UtilsService) {}

  @Input() produitDeclinaison: ProduitDeclinaisonDTO;
  @ViewChild('grid') dataGrid: DxDataGridComponent;
  private subSave: Subscription;
  private subOpenDialog: Subscription;
  private subAllStockMinmum: Subscription;
  displayDialog = false;
  stockMinimumList: StockMinimum[];
  stockMinimumAmount: number;

  ngOnInit() {
    this.initSubDialog();
  }

  ngOnDestroy() {
    this.utils.unsubscribe(this.subOpenDialog);
    this.utils.unsubscribe(this.subAllStockMinmum);
    this.utils.unsubscribe(this.subSave);
  }

  private initSubDialog() {
    this.subOpenDialog = this.stockSvc.openDialogGestionStockMini$.subscribe(() => {
      this.initStockMinimum();
      this.displayDialog = true;
    });
  }

  private initStockMinimum() {
    this.subAllStockMinmum = this.stockSvc.getStockMinimumList(this.produitDeclinaison.id).subscribe((response) => {
        this.stockMinimumList = response.resultList
      }
    );
  }

  appliquerEnMasse = (): void => {
    const selectedSites = this.dataGrid.instance.getSelectedRowsData().map(item => item.site.id)
    if (selectedSites.length > 0) {
      this.stockMinimumList.filter(stockMinimum => selectedSites.includes(stockMinimum.site.id)).forEach(stockMinimum => {
        stockMinimum.amount = this.stockMinimumAmount;
      })
    } else {
      this.stockMinimumList.forEach(stockMinmum => stockMinmum.amount = this.stockMinimumAmount);
    }
    this.dataGrid.instance.clearSelection();
  }

  closeDialog = () => {
    this.displayDialog = false;
  }

  save = () => {
    this.subSave = this.stockSvc.saveStockMinimumList(this.produitDeclinaison.id, this.stockMinimumList).subscribe(res => this.stockMinimumList = res.resultList);
    this.displayDialog = false;
  }
}
